"use client";

import { useTranslations } from "next-intl";
import { SidebarTrigger } from "@/components/ui/sidebar";

export function DashboardLayoutHeader() {
  const t = useTranslations("disclaimer");

  return (
    <div className="flex items-center gap-2 border-b border-border px-4 py-3 lg:px-6">
      <SidebarTrigger className="text-muted-foreground hover:text-foreground" />
      <div className="h-4 w-px bg-border" />
      <p className="text-xs text-muted-foreground">
        {t("title")} {t("message").split(".")[0]}.
      </p>
    </div>
  );
}
